import { Stack } from '@mui/material';

import { isTruthy, useResizableDrawer } from 'common';

import { AGENTIC_CHAT_PRODUCT_NAME } from './constants';
import { useAgenticChatContext } from './context';
import { ErrorBoundary } from '../../ErrorBoundry';
import { AgenticChatPage } from '../../scenes/AgenticChat/Page';
import { DrawerResizeHandle } from '../Drawer/ResizeHandle';

export function AgenticChatHost() {
  const { agenticChatVisibility, viewMode, drawerSizing } = useAgenticChatContext();
  const {
    defaultWidth,
    drawerWidth,
    maximumDrawerWidth,
    isResizingDrawer,
    onStartResizingDrawer,
    onResetDrawerWidth,
    setDrawerWidthAndPersist,
  } = useResizableDrawer({
    drawerPlacement: 'Right',
    localStorageKey: 'flowAi:drawerWidth',
    ...drawerSizing,
    maximumDrawerWidthInPixels: 900,
  });

  const isVisible = agenticChatVisibility === 'Open';

  return (
    <Stack
      id="global-flow-ai"
      role="region"
      aria-label={`${AGENTIC_CHAT_PRODUCT_NAME} conversation`}
      aria-hidden={!isTruthy(isVisible)}
      inert={!isTruthy(isVisible)}
      sx={{
        display: viewMode === 'Fullscreen' && !isTruthy(isVisible) ? 'none' : 'flex',
        position: viewMode === 'Fullscreen' ? 'absolute' : 'relative',
        ...(viewMode === 'Fullscreen' && { inset: 0 }),
        width: viewMode === 'Fullscreen' ? '100%' : isTruthy(isVisible) ? drawerWidth : 0,
        maxWidth: viewMode === 'Fullscreen' ? '100%' : maximumDrawerWidth,
        minWidth: 0,
        flexShrink: 0,
        overflow: 'hidden',
        zIndex: viewMode === 'Fullscreen' ? 1 : undefined,
      }}
    >
      {agenticChatVisibility !== 'Unopened' && (
        <Stack
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            backgroundColor: 'background.paper',
            borderLeft: viewMode === 'Fullscreen' ? 0 : 1,
            borderColor: 'divider',
            transform:
              viewMode !== 'Fullscreen' && !isTruthy(isVisible)
                ? 'translateX(100%)'
                : 'translateX(0)',
          }}
        >
          <ErrorBoundary>
            <AgenticChatPage />
          </ErrorBoundary>
        </Stack>
      )}
      {isTruthy(isVisible) && viewMode !== 'Fullscreen' && (
        <Stack>
          <DrawerResizeHandle
            label={`Resize ${AGENTIC_CHAT_PRODUCT_NAME} sidebar`}
            isResizing={isResizingDrawer}
            width={drawerWidth}
            minimumWidth={defaultWidth}
            maximumWidth={maximumDrawerWidth}
            onStartResizing={(event) => onStartResizingDrawer(event)}
            onChangeWidth={(width) => setDrawerWidthAndPersist(width)}
            onResetWidth={() => onResetDrawerWidth()}
          />
        </Stack>
      )}
    </Stack>
  );
}
